export default __webpack_public_path__ + "static/galvanic2-2a9fcdc049c1e6c9abec97f48fd6e7e1.jpg";